@if (model) {
  <pre>
    {{model.firstName}} {{model.lastName}}
    {{model.email}}
    {{model.formattedUserExpenseValue}}
  </pre>
}
